














































































































































import TabsInfoMixin from '../../devices/TabsInfoMixin';
import Component from 'vue-class-component';
import { Mixins } from 'vue-mixin-decorator';
import { Prop } from 'vue-property-decorator';
import { Global, Props, Groups } from '@/store';
import Utils from '@/modules/Utils';
import PropUtils from '@/modules/PropUtils';
import mapConfig from '@/pages/mapView/components/map/map.config';
// @ts-ignore
import VueQRCodeComponent from 'vue-qrcode-component';

@Component({
    components: {
        VueQRCodeComponent
    }
})

class OverviewTab extends Mixins<TabsInfoMixin>(TabsInfoMixin) {
    @Global.State('lang') lang;
    @Groups.State('list') groups;
    @Props.State('list') projectProperties;

    // @ts-ignore
    @Prop() device;
    @Prop() metaDevice;
    @Prop() streamPower;
    @Prop() converted;
    @Prop() daliToPercentTable;
    @Prop() streamVersion;
    @Prop() group_ids;

    qrcode = '';
    size = 150;
    loading = true;
    relatedGroups = [];
    has_astronomical_clock = false;
    part_number_desc = '';

    async created(){
        this.loading = true;
        this.generateQRcode();
        this.setRelatedGroups();
        this.has_astronomical_clock = PropUtils.hasAstronomicalClock(this.device.id);
        const part_number_list = PropUtils.getProjectPropertyData(this.projectProperties, 'controller.part_number_list');
        this.part_number_desc = part_number_list && this.device['meta.part_number.part_number']
            ? part_number_list[this.device['meta.part_number.part_number']]
            : '';

        this.loading = false;
    }

    generateQRcode(){
        const hardwareidProp = this.device['device.hardwareid'];
        if (hardwareidProp){
            const cpu_id = hardwareidProp.id ? hardwareidProp.id : '';
            const mac_id = hardwareidProp.mac ? hardwareidProp.mac : '';
            this.qrcode = cpu_id && mac_id ? `${cpu_id} ${mac_id}` : '';
        }else this.qrcode = '';
    }

    setRelatedGroups(){
        this.relatedGroups = this.group_ids
          .map((group_id) => {
            const group_data = this.groups.find((group) => group.id === group_id);
            return group_data && group_data.name || '';
          })
          .filter((group_name) => group_name);
    }

    get poleNumber() {
        return this.metaDevice && this.metaDevice.pole_number || 'N/A';
    }

    get cabinetId() {
        return this.metaDevice && this.metaDevice.cabinet_id || 'N/A';
    }

    get circuitNumber() {
        return this.metaDevice && this.metaDevice.circuit_number || 'N/A';
    }

    get dimmingLevel() {
        return Utils.getPercentValue(this.converted, this.daliToPercentTable, this.streamPower);
    }

    get connected_status(){
        return this.device.sys___connected === 0 
            ? 'Disconnected' 
            : this.device.sys___connected === 1
            ? 'Connected' 
            : 'Unknown';
    }

    get active_status() {
        return this.device.sys___active === 0 
            ? 'Inactive' 
            : this.device.sys___active === -1
            ? 'Maintenance'
            : this.device.sys___active === -3
            ? 'In Installation'
            : this.device.sys___active === -9
            ? 'Fault In Care'
            : this.device.sys___active === 1
            ? 'Active'
            : 'Unknown';
    }

    get clockIcon() {
        return this.has_astronomical_clock
            ? mapConfig.icons.astronomicalClock
            : mapConfig.icons.noAstronomicalClock;
    }

    get clockText() {
        return this.has_astronomical_clock
            ? 'Yes'
            : 'No';
    }

    get imsi() {
        return this.device['meta.imsi.imsi'] || 'N/A';
    }
}

export default OverviewTab;
